/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type settingsDepartments_department = {
    readonly id: string;
    readonly name: string | null;
    readonly sageIntacctId: string | null;
    readonly " $refType": "settingsDepartments_department";
};
export type settingsDepartments_department$data = settingsDepartments_department;
export type settingsDepartments_department$key = {
    readonly " $data"?: settingsDepartments_department$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"settingsDepartments_department">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsDepartments_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctId",
      "storageKey": null
    }
  ],
  "type": "DepartmentType"
};
(node as any).hash = 'be83e662fd1cf7ee403c326f55b2425e';
export default node;
